import { PageModule } from "@/routes/types";
import { Page } from "./page";
import { loader } from "./loader";

export default { name: "ResourceHubDocumentVersionComparisonPage", loader, Page } as PageModule;
